var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.accessToken
    ? _c("section", { staticClass: "section section-background-grey" }, [
        _c("div", { staticClass: "section-content" }, [
          _c("div", { staticClass: "has-text-centered" }, [
            _c("div", { staticClass: "title is-spaced" }, [
              _vm._v(_vm._s(_vm.$t("about.title6"))),
            ]),
            _c("p", { staticClass: "subtitle" }, [
              _vm._v(_vm._s(_vm.$t("about.submit_phone_number"))),
            ]),
          ]),
          _c("div", { staticClass: "form-container form-inline" }, [
            _c(
              "div",
              { staticClass: "columns is-centered is-vcentered is-multiline" },
              [
                _c("div", { staticClass: "column" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("label", { staticClass: "label" }, [
                      _vm._v(_vm._s(_vm.$t("label.name_surname"))),
                    ]),
                    _c("div", { staticClass: "control" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.name,
                            expression: "name",
                          },
                        ],
                        staticClass: "input",
                        attrs: {
                          type: "text",
                          disabled: _vm.formSubmit || _vm.errorSubmit,
                          maxlength: "50",
                        },
                        domProps: { value: _vm.name },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.name = $event.target.value
                          },
                        },
                      }),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "column" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("label", { staticClass: "label" }, [
                      _vm._v(_vm._s(_vm.$t("label.email"))),
                    ]),
                    _c("div", { staticClass: "control" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.email,
                            expression: "email",
                          },
                        ],
                        staticClass: "input",
                        attrs: {
                          type: "text",
                          disabled: _vm.formSubmit || _vm.errorSubmit,
                          maxlength: "50",
                        },
                        domProps: { value: _vm.email },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.email = $event.target.value
                          },
                        },
                      }),
                    ]),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "column is-full no-padding-vertical" },
                  [
                    _c("div", { staticClass: "field" }, [
                      _c("label", { staticClass: "label" }, [
                        _vm._v(_vm._s(_vm.$t("label.message"))),
                      ]),
                      _c("div", { staticClass: "control" }, [
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.message,
                              expression: "message",
                            },
                          ],
                          staticClass: "textarea",
                          attrs: {
                            disabled: _vm.formSubmit || _vm.errorSubmit,
                            rows: "5",
                          },
                          domProps: { value: _vm.message },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.message = $event.target.value
                            },
                          },
                        }),
                      ]),
                    ]),
                  ]
                ),
                !_vm.formSubmit
                  ? _c("div", { staticClass: "column no-grow" }, [
                      _c("div", { staticClass: "field" }, [
                        _c(
                          "div",
                          { staticClass: "control has-text-centered" },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "button is-primary",
                                class: _vm.buttonClass,
                                attrs: {
                                  type: "button",
                                  disabled: _vm.formSubmit || _vm.errorSubmit,
                                },
                                on: { click: _vm.submitRequest },
                              },
                              [_vm._v(_vm._s(_vm.$t("button.submit")))]
                            ),
                          ]
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ]
            ),
            _vm.formSubmit
              ? _c(
                  "article",
                  {
                    staticClass: "message is-success",
                    attrs: { transition: "fade" },
                  },
                  [
                    _c("div", { staticClass: "message-body" }, [
                      _vm._v(_vm._s(_vm.$t("alert.request_sent"))),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm.errorSubmit
              ? _c(
                  "article",
                  {
                    staticClass: "message is-danger",
                    attrs: { transition: "fade" },
                  },
                  [
                    _c("div", { staticClass: "message-body" }, [
                      _vm._v(_vm._s(_vm.$t("alert.error"))),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm.invalidSubmit
              ? _c(
                  "article",
                  {
                    staticClass: "message is-danger",
                    attrs: { transition: "fade" },
                  },
                  [
                    _c("div", { staticClass: "message-body" }, [
                      _vm._v(_vm._s(_vm.$t("alert.request_invalid"))),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm.errorName
              ? _c(
                  "article",
                  {
                    staticClass: "message is-danger",
                    attrs: { transition: "fade" },
                  },
                  [
                    _c("div", { staticClass: "message-body" }, [
                      _vm._v(_vm._s(_vm.$t("alert.missing_name"))),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm.errorMessage
              ? _c(
                  "article",
                  {
                    staticClass: "message is-danger",
                    attrs: { transition: "fade" },
                  },
                  [
                    _c("div", { staticClass: "message-body" }, [
                      _vm._v(_vm._s(_vm.$t("alert.missing_message"))),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm.errorEmail
              ? _c(
                  "article",
                  {
                    staticClass: "message is-danger",
                    attrs: { transition: "fade" },
                  },
                  [
                    _c("div", { staticClass: "message-body" }, [
                      _vm._v(_vm._s(_vm.$t("alert.missing_email"))),
                    ]),
                  ]
                )
              : _vm._e(),
            !_vm.formSubmit
              ? _c("p", { staticClass: "has-text-justified privacy-text" }, [
                  _vm._v(_vm._s(_vm.$t("privacy.email_form"))),
                ])
              : _vm._e(),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }